import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import ReactRouterPropTypes from 'react-router-prop-types';

import {SUSI_URL} from 'lib/shared/config/config';
import {withMarketInfo} from 'context/MarketInfo/MarketInfoProvider';
import {configPropType, marketInfoPropType} from 'utils/custom-proptypes';
import {captureException} from 'lib/client/sentry/sentry';
import {getI18nDateTime} from 'lib/shared/i18n/i18n';
import {withConfig} from 'context/Config/ConfigProvider';

import NotificationModal from './NotificationModal/NotificationModal';
import NotificationBanner from './NotificationBanner/NotificationBanner';

function getFormattedDate(longDate, locale) {
  const lastUpdated = new Date(longDate);
  return getI18nDateTime(lastUpdated, locale);
}

// Exported for testability
export function getNotificationsByPath(notificationData, pathname, locale) {
  const pathContactForm = pathname.startsWith('/contact-spotify-');
  const pathCloseAccount = pathname.startsWith('/close-account');

  if (pathCloseAccount) {
    return {};
  }

  const response = {};
  if (pathContactForm && notificationData.contact_form && notificationData.contact_form.type === 'issue') {
    response.modalNotification = getFormattedNotification(notificationData.contact_form, locale);
  }
  if (notificationData.support) {
    response.bannerNotification = getFormattedNotification(notificationData.support, locale);
  }

  return response;
}

function getFormattedNotification(notificationData, locale) {
  return {
    body: notificationData.body,
    lastUpdated: getFormattedDate(notificationData.last_updated, locale),
    type: notificationData.type,
  };
}

class Notifications extends Component {
  static propTypes = {
    marketInfo: marketInfoPropType,
    location: ReactRouterPropTypes.location.isRequired,
    config: configPropType,
  };

  constructor(props) {
    super(props);

    this.state = {
      notificationData: null,
      showModal: false,
    };
  }

  async componentDidMount() {
    const sfMarket = this.props.marketInfo.sfMarket || 'default';
    const encodedSfMarket = encodeURIComponent(sfMarket);
    try {
      const response = await fetch(`${SUSI_URL}/notification/${encodedSfMarket}`);
      if (response.ok) {
        this.setState({notificationData: await response.json()});
      } else {
        captureException(`Fetching notifications, got: ${response.status}`);
      }
    } catch (e) {
      captureException(e);
    }
  }

  getNotifications() {
    const notificationData = this.state.notificationData;
    if (!notificationData) {
      return null;
    }
    const locale = this.props.marketInfo.locale;
    const pathname = this.props.location.pathname;

    return getNotificationsByPath(notificationData, pathname, locale);
  }

  render() {
    const {config} = this.props;
    const notifications = this.getNotifications();
    if (config.plainUI || !notifications) {
      return null;
    }

    const {bannerNotification, modalNotification} = notifications;

    return (
      <>
        {bannerNotification && <NotificationBanner notification={bannerNotification} />}
        {modalNotification && <NotificationModal notification={modalNotification} />}
      </>
    );
  }
}

export default withMarketInfo(withConfig(withRouter(Notifications)));
